// ===== E2S STOREFRONT SCRIPT =====
// Tracked replacement for the COMMERCE blocks of the legacy DB "Website Script"
// (Checkify autocomplete, cart core, shop add-to-cart, stash page logic).
// Chrome blocks (auth panel, navbar, user state, logout, contact reveal,
// portal nav, redirects) intentionally REMAIN in the DB Website Script record.
// Plain browser script — no modules. localStorage contract: srt_cart,
// srt_customer, srt_shipping (byte-compatible with the legacy script).

// ── CHECKIFY AUTOCOMPLETE ──────────────────────────
(function() {
  var script = document.createElement('script');
  script.src = 'https://cdn.jsdelivr.net/npm/@checkify-api/autocomplete@latest/checkify-autocomplete.js?key=ck_pub_xuESvcHU7gwxs3BAbbasPDjSZLb4GymH64998H9F094cc188';
  script.onload = function() {
    if (typeof CheckifyAutocomplete !== 'undefined') {
      if (document.getElementById('ship-addr1')) {
        CheckifyAutocomplete.init('#ship-addr1', {
          street: '#ship-addr1', city: '#ship-city', state: '#ship-state', postcode: '#ship-postcode'
        });
      }
      if (document.getElementById('bill-addr1')) {
        CheckifyAutocomplete.init('#bill-addr1', {
          street: '#bill-addr1', city: '#bill-city', state: '#bill-state', postcode: '#bill-postcode'
        });
      }
    }
  };
  document.head.appendChild(script);
})();
// ── CART ──────────────────────────
function getCart() {
  try { return JSON.parse(localStorage.getItem('srt_cart') || '{}'); } catch(e) { return {}; }
}
// best-effort persistence: a browser with site data blocked (private window,
// storage full) still shops — the cart lives in the page for this visit and is
// simply not remembered for the next one. Nothing here is the record of an
// order, so there is no write to log and nothing to tell the shopper about.
function saveCart(cart) { try { localStorage.setItem('srt_cart', JSON.stringify(cart)); } catch(e) { /* see above: the cart is page-local when storage refuses */ } }
function updateCartCount() {
  try {
    var cart = getCart();
    var count = Object.values(cart).reduce(function(s, i) { return s + i.qty; }, 0);
    var badge = document.getElementById('cart-count');
    if (badge) { badge.textContent = count; badge.style.display = count === 0 ? 'none' : ''; }
  } catch(e) { /* the badge is a count on chrome: an unreadable cart leaves the
    previous number showing rather than taking the page down around it */ }
}
function addToCart(code, qty, name, img, price, uom) {
  var cart = getCart();
  if (cart[code]) cart[code].qty += qty;
  else cart[code] = { item_code: code, item_name: name, image: img, price: price, uom: uom, qty: qty };
  saveCart(cart);
  updateCartCount();
  return cart[code].qty;
}
// ── SHOP GRID/LIST TOGGLE ─────────
// (was only in the DB Website Script; the Shop page's toggle button calls it)
function toggleListView(e) { e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation(); var grid = document.querySelector('.card-list'), btn = document.getElementById('toggle-view-btn'); if (!grid || !btn) return; grid.classList.toggle('card-list--grid'); if (grid.classList.contains('card-list--grid')) { btn.innerHTML = '<i class="fa-solid fa-list"></i>'; btn.setAttribute('title', 'List View'); } else { btn.innerHTML = '<i class="fa-solid fa-grip"></i>'; btn.setAttribute('title', 'Grid View'); } return false; }
window.toggleListView = toggleListView;
// ── SHOP CARD ACTIONS ─────────────
document.addEventListener('DOMContentLoaded', function() { document.querySelectorAll('.card-actions .btn-primary').forEach(function(btn) { btn.addEventListener('click', function(e) { e.preventDefault(); e.stopPropagation(); var itemCode = this.getAttribute('data-item'), qtyInput = document.getElementById('qty-' + itemCode), qty = qtyInput ? parseInt(qtyInput.value) || 1 : 1, itemName = this.getAttribute('data-name'), itemImage = this.getAttribute('data-image'), itemPrice = parseFloat(this.getAttribute('data-price')) || 0, itemUom = this.getAttribute('data-uom') || 'Nos', icon = this.querySelector('i'), originalClass = icon.className; icon.className = 'fa-solid fa-spinner fa-spin'; this.disabled = true; if (typeof addToCart === 'function') { addToCart(itemCode, qty, itemName, itemImage, itemPrice, itemUom); } else { var cart = JSON.parse(localStorage.getItem('srt_cart') || '{}'); if (cart[itemCode]) { cart[itemCode].qty += qty; } else { cart[itemCode] = { item_code: itemCode, item_name: itemName, image: itemImage, price: itemPrice, uom: itemUom, qty: qty }; } localStorage.setItem('srt_cart', JSON.stringify(cart)); if (typeof updateCartCount === 'function') updateCartCount(); } icon.className = 'fa-solid fa-check'; setTimeout(function() { this.disabled = false; icon.className = originalClass; }, 1500); }); }); });
// ============================================
// ── STASH PAGE LOGIC ───────────────────────
// ============================================
var stashShippingAmount = 0;
var stashShippingCalculated = false;
var stashPrices = {};
function initStash() {
  var cart = getCart();
  var items = Object.values(cart);
  if (items.length === 0) {
    document.getElementById('cart-empty').style.display = 'block';
    document.getElementById('guest-actions').style.display = 'none';
    document.getElementById('logged-in-actions').style.display = 'none';
    return;
  }

  items.forEach(function(item) { stashPrices[item.item_code] = item.price || 0; });

  renderStashCart(items);
  updateStashTotals();
  updateStashUI();

  var calcBtn = document.getElementById('calc-shipping-btn');
  if (calcBtn) {
    calcBtn.addEventListener('click', calculateStashShipping);
    calcBtn.style.opacity = '1';
    calcBtn.style.cursor = 'pointer';
    calcBtn.style.pointerEvents = 'auto';
  }

  updateCalcButtonState();

  var checkoutBtn = document.getElementById('checkout-btn-final');
  if (checkoutBtn) checkoutBtn.addEventListener('click', stashCheckout);

  var loginBtn = document.getElementById('btn-open-login');
  var signupBtn = document.getElementById('btn-open-signup');
  if (loginBtn) loginBtn.addEventListener('click', function() { if (typeof openAuthPanel === 'function') { openAuthPanel('login'); } else { window.location.href = '/login'; } });
  if (signupBtn) signupBtn.addEventListener('click', function() { if (typeof openAuthPanel === 'function') { openAuthPanel('signup'); } else { window.location.href = '/login'; } });

  var billingCheck = document.getElementById('billing-different');
  if (billingCheck) billingCheck.addEventListener('change', function() { document.getElementById('billing-address').style.display = this.checked ? 'block' : 'none'; });
  setupStashValidation();
}
function updateCalcButtonState() {
  var postcode = document.getElementById('ship-postcode');
  var calcBtn = document.getElementById('calc-shipping-btn');
  if (!postcode || !calcBtn) return;
  var valid = postcode.value.trim().length === 4;
  calcBtn.style.opacity = valid ? '1' : '0.5';
  calcBtn.style.cursor = valid ? 'pointer' : 'not-allowed';
  calcBtn.style.pointerEvents = valid ? 'auto' : 'none';
}
function setupStashValidation() {
  var requiredFields = ['cust-firstname','cust-lastname','cust-mobile','cust-email','ship-addr1','ship-city','ship-state','ship-postcode'];
  [].concat(requiredFields, ['bill-addr1','bill-city','bill-state','bill-postcode', 'billing-different']).forEach(function(id) {
    var el = document.getElementById(id);
    if (el) { el.addEventListener('input', checkStashReady); el.addEventListener('change', checkStashReady); }
  });
}
function renderStashCart(items) {
  var container = document.getElementById('cart-items');
  if (!container) return;
  container.innerHTML = '';
  items.forEach(function(item) {
    var price = stashPrices[item.item_code] || 0;
    var row = document.createElement('div');
    row.className = 'card-item';
    row.innerHTML = '<div class="card-image"><img src="' + (item.image || '/assets/e2s/images/product-placeholder.svg') + '" alt="' + item.item_name + '"></div>' +
      '<div class="card-content"><div class="card-title">' + item.item_name + '</div><div class="card-cat">' + item.item_code + '</div></div>' +
      '<div class="card-price"><div class="card-price-value">$' + (price * item.qty).toFixed(2) + '</div><div class="card-price-unit">$' + price.toFixed(2) + ' each</div></div>' +
      '<div class="card-actions"><input type="number" class="card-qty" data-item="' + item.item_code + '" value="' + item.qty + '" min="0"><button aria-label="Remove from stash" class="cart-remove" data-item="' + item.item_code + '">🗑</button></div>';
    container.appendChild(row);
  });

  document.querySelectorAll('.card-qty').forEach(function(input) { input.addEventListener('change', function() { var code = this.getAttribute('data-item'), qty = parseInt(this.value) || 0, cart = getCart(); if (cart[code]) { cart[code].qty = qty; saveCart(cart); updateStashTotals(); renderStashCart(Object.values(cart)); } }); });
  document.querySelectorAll('.cart-remove').forEach(function(btn) { btn.addEventListener('click', function() {
    var code = this.getAttribute('data-item'), cart = getCart();
    delete cart[code]; saveCart(cart);
    var items = Object.values(cart);
    if (items.length === 0) {
      document.getElementById('cart-items').innerHTML = '';
      document.getElementById('cart-summary').style.display = 'none';
      document.getElementById('cart-empty').style.display = 'block';
      document.getElementById('customer-details').style.display = 'none';
      document.getElementById('guest-actions').style.display = 'none';
      document.getElementById('logged-in-actions').style.display = 'none';
    } else { renderStashCart(items); updateStashTotals(); }
    updateCartCount();
  }); });
}
function updateStashTotals() {
  var cart = getCart(), its = Object.values(cart), count = its.reduce(function(s, i) { return s + i.qty; }, 0), sub = 0;
  its.forEach(function(i) { sub += (stashPrices[i.item_code] || 0) * i.qty; });
  var total = sub + stashShippingAmount;
  var ci = document.getElementById('cart-item-count'), cs = document.getElementById('cart-subtotal'), ct = document.getElementById('cart-total');
  if (ci) ci.textContent = count;
  if (cs) cs.textContent = sub.toFixed(2);
  if (ct) ct.textContent = '$' + total.toFixed(2);
  checkStashReady();
}
function calculateStashShipping() {
  var postcode = document.getElementById('ship-postcode').value.trim();
  if (!postcode || postcode.length !== 4) { return; }
  var btn = document.getElementById('calc-shipping-btn');
  btn.textContent = 'Calculating...';
  btn.style.opacity = '0.5';
  btn.style.pointerEvents = 'none';
  var cart = getCart();
  var cartParam = encodeURIComponent(JSON.stringify(cart));
  fetch('/api/method/e2s.api.commerce.shipping.lookup_postcode?postcode=' + postcode + '&cart=' + cartParam)
    .then(function(r) { return r.json(); }).then(function(d) {
      var data = d.message || d, resultEl = document.getElementById('shipping-result'), shippingDisplay = document.getElementById('shipping-display');
      stashShippingAmount = data.shipping_rate || 0;
      stashShippingCalculated = true;
      resultEl.textContent = data.label + ' — ' + (stashShippingAmount > 0 ? '$' + stashShippingAmount.toFixed(2) : 'Free');
      resultEl.style.color = '#2d6a4f';
      resultEl.style.display = 'block';
      shippingDisplay.textContent = stashShippingAmount > 0 ? '$' + stashShippingAmount.toFixed(2) : 'Free';
      updateStashTotals();
      localStorage.setItem('srt_shipping', stashShippingAmount);
      btn.textContent = 'Calculate Shipping';
      btn.style.opacity = '1';
      btn.style.cursor = 'pointer';
      btn.style.pointerEvents = 'auto';
    }).catch(function() {
      btn.textContent = 'Calculate Shipping';
      btn.style.opacity = '1';
      btn.style.cursor = 'pointer';
      btn.style.pointerEvents = 'auto';
    });
}
function checkStashReady() {
  var btn = document.getElementById('checkout-btn-final'), hint = document.getElementById('checkout-hint');
  var allFilled = checkStashRequiredFields();
  if (allFilled && stashShippingCalculated) {
    btn.style.opacity = '1'; btn.style.cursor = 'pointer'; btn.style.pointerEvents = 'auto';
    if (hint) hint.style.display = 'none';
  } else {
    btn.style.opacity = '0.5'; btn.style.cursor = 'not-allowed'; btn.style.pointerEvents = 'none';
    // WORDING (docs/CLAIMS_POLICY.md dignity rules, A5a audit 2026-08-30):
    // a hint says what is still open, it does not issue instructions at the
    // person standing in front of the form.
    if (hint) { if (!allFilled) hint.textContent = 'A few of the details above are still blank, and shipping has not been worked out yet.'; else if (!stashShippingCalculated) hint.textContent = 'Shipping has not been worked out yet — the Calculate Shipping button does it.'; }
  }
}
function checkStashRequiredFields() {
  var fields = ['cust-firstname','cust-lastname','cust-mobile','cust-email','ship-addr1','ship-city','ship-state','ship-postcode'];
  return fields.every(function(id) { var el = document.getElementById(id); return el && el.value.trim(); });
}
function updateStashUI() {
  var guestActions = document.getElementById('guest-actions'), loggedInActions = document.getElementById('logged-in-actions'), details = document.getElementById('customer-details');
  if (typeof frappe !== 'undefined' && frappe.session && frappe.session.user && frappe.session.user !== 'Guest') {
    if (guestActions) guestActions.style.display = 'none';
    if (loggedInActions) loggedInActions.style.display = 'flex';
    if (details) details.style.display = 'block';
    fetch('/api/resource/User/' + encodeURIComponent(frappe.session.user)).then(function(r) { return r.json(); }).then(function(d) { var u = d.data || {}; if (u.first_name) document.getElementById('cust-firstname').value = u.first_name || ''; if (u.last_name) document.getElementById('cust-lastname').value = u.last_name || ''; if (u.mobile_no) document.getElementById('cust-mobile').value = u.mobile_no || ''; if (u.email) document.getElementById('cust-email').value = u.email || ''; });
    fetch('/api/method/e2s.api.commerce.customer.get_customer_details').then(function(r) { return r.json(); }).then(function(d) {
      var data = d.message || d;
      if (data.shipping) {
        var s = data.shipping;
        if (s.address_line1) document.getElementById('ship-addr1').value = s.address_line1 || '';
        if (s.address_line2) document.getElementById('ship-addr2').value = s.address_line2 || '';
        if (s.city) document.getElementById('ship-city').value = s.city || '';
        if (s.state) document.getElementById('ship-state').value = s.state || '';
        if (s.pincode) { document.getElementById('ship-postcode').value = s.pincode || ''; updateCalcButtonState(); }
        if (s.email_id) document.getElementById('cust-email').value = s.email_id || '';
        if (s.phone) document.getElementById('cust-mobile').value = s.phone || '';
      }
    });
  } else {
    if (guestActions) guestActions.style.display = 'flex';
    if (loggedInActions) loggedInActions.style.display = 'none';
    if (details) details.style.display = 'none';
  }
}
// L01-F2 / L01-G4, 2026-09-05. The account-minting door at the foot of this
// page (create_or_update_from_stash) now asks for the same proof of work the
// trial door and the feedback door ask for, so this fetches a challenge and
// answers it before posting. ONE formulation of the sum: pow.js is imported by
// URL rather than reimplemented here, so this page and the server cannot come
// to disagree about what a valid answer is.
//
// IT NEVER BLOCKS A SHOPPER ON ITS OWN. Every failure — no challenge, no
// module, a slow phone that ran out of deadline — resolves to {} and the post
// goes anyway, and the SERVER answers in its own words. A page that refused to
// submit because its own sum did not land would lock somebody out of paying.
var POW_MODULE_URL = '/assets/e2s/js/engine/pow.js';
function stashProof() {
  return fetch('/api/method/e2s.api.pow.challenge', { method: 'POST', headers: {'Content-Type': 'application/json'} })
    .then(function(r) { return r.json(); })
    .then(function(d) {
      var c = (d && d.message) || {};
      if (!c.nonce) return {};
      // The URL is held in a variable ON PURPOSE (r71 deploy, 2026-09-05):
      // esbuild resolves a string-literal dynamic import at BUILD time and an
      // absolute asset URL has nothing to resolve to on disk, which broke the
      // bench build ("Could not resolve /assets/e2s/js/engine/pow.js"). A
      // non-literal argument is left for the browser, which fetches the served
      // module — the same file the trial page and the demo door import, so the
      // one-formulation rule above still holds.
      var powUrl = POW_MODULE_URL;
      return import(powUrl).then(function(pow) {
        return pow.solve(c.nonce, c.difficulty).then(function(sol) {
          return sol ? { pow_nonce: c.nonce, pow_solution: sol } : {};
        });
      });
    })
    .catch(function() { return {}; });
}
function stashCheckout(e) {
  e.preventDefault();
  if (!checkStashRequiredFields()) { alert('Some of the details above are still blank — checkout files the order under all of them.'); return; }
  var btn = document.getElementById('checkout-btn-final'); btn.textContent = 'Validating...'; btn.disabled = true;
  var cart = getCart();
  fetch('/api/method/e2s.api.commerce.cart.validate_cart?cart=' + encodeURIComponent(JSON.stringify(cart)))
    .then(function(r) { return r.json(); }).then(function(d) {
      var data = d.message || d;
      if (data.validated) {
        var updatedCart = {}; data.line_items.forEach(function(item) { updatedCart[item.item_code] = { item_code: item.item_code, item_name: item.item_name, image: item.image, price: item.rate, uom: item.uom, qty: item.qty }; }); saveCart(updatedCart);
        var customerData = { firstname: document.getElementById('cust-firstname').value.trim(), lastname: document.getElementById('cust-lastname').value.trim(), mobile: document.getElementById('cust-mobile').value.trim(), email: document.getElementById('cust-email').value.trim(), shipping: { addr1: document.getElementById('ship-addr1').value.trim(), addr2: document.getElementById('ship-addr2').value.trim(), city: document.getElementById('ship-city').value.trim(), state: document.getElementById('ship-state').value, postcode: document.getElementById('ship-postcode').value.trim(), country: document.getElementById('ship-country').value } };
        if (document.getElementById('billing-different').checked) { customerData.billing = { addr1: document.getElementById('bill-addr1').value.trim(), addr2: document.getElementById('bill-addr2').value.trim(), city: document.getElementById('bill-city').value.trim(), state: document.getElementById('bill-state').value, postcode: document.getElementById('bill-postcode').value.trim(), country: document.getElementById('bill-country').value }; }
        localStorage.setItem('srt_customer', JSON.stringify(customerData));
        fetch('/api/method/e2s.api.commerce.customer.create_or_update_from_stash', { method: 'POST', headers: {'Content-Type': 'application/json'}, body: JSON.stringify(customerData) })
          .then(function(r) { return r.json(); }).then(function(cd) { if (cd.message && cd.message.success) { if (data.warnings && data.warnings.length > 0) alert('Price update:\n\n• ' + data.warnings.join('\n• ')); window.location.href = '/checkout'; } else { alert("Those details didn't save — nothing has been lost, and the stash is still here."); btn.textContent = 'Checkout →'; btn.disabled = false; } })
          .catch(function() { alert("Those details didn't save — nothing has been lost, and the stash is still here."); btn.textContent = 'Checkout →'; btn.disabled = false; });
      } else { alert(data.error || "The stash didn't read back just now — nothing has been lost."); btn.textContent = 'Checkout →'; btn.disabled = false; }
    }).catch(function() { alert("The stash didn't read back just now — nothing has been lost."); btn.textContent = 'Checkout →'; btn.disabled = false; });
}
document.addEventListener('input', function(e) {
  if (e.target && e.target.id === 'ship-postcode') { updateCalcButtonState(); }
});
// ── INIT ──────────────────────────
document.addEventListener('DOMContentLoaded', function() {
  setTimeout(updateCartCount, 300);
  if (document.getElementById('cart-items') && window.location.pathname === '/stash') {
    var cart = getCart();
    var items = Object.values(cart);
    if (items.length > 0) {
      document.getElementById('cart-summary').style.display = 'block';
      document.getElementById('cart-empty').style.display = 'none';
    } else {
      document.getElementById('cart-summary').style.display = 'none';
      document.getElementById('cart-empty').style.display = 'block';
      document.getElementById('guest-actions').style.display = 'none';
      document.getElementById('logged-in-actions').style.display = 'none';
      document.getElementById('customer-details').style.display = 'none';
      return;
    }
    initStash();
    setTimeout(function() {
      updateStashUI();
      if (typeof detectUserState === 'function') detectUserState();
    }, 500);
    setTimeout(function() {
      updateStashUI();
      if (typeof detectUserState === 'function') detectUserState();
    }, 1500);
    setTimeout(function() {
      updateStashUI();
      if (typeof detectUserState === 'function') detectUserState();
    }, 3000);
  }
});
